import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import KDSTopNav from '@decisiv/ui-components/lib/components/TopNav';

import { t } from '@lingui/macro';

import { CurrentInvitationContext } from 'utils/Invitation';
import { useCurrentUserContext } from 'utils/User';

import useSentinelTeam from 'hooks/useSentinelTeam';
import useIsOutsideTeamScope from 'hooks/useIsOutsideTeamScope';
import decisivLogo from './decisiv.png';

function BrandInfo(props) {
  /* istanbul ignore next -- @preserve */
  const { variant = 'full' } = props;
  const { sentinelTeam: invitationSentinelTeam } = useContext(
    CurrentInvitationContext,
  );
  const { needsSentinelTeam } = useCurrentUserContext();
  const userSentinelTeam = useSentinelTeam();
  const isOutsideTeamScope = useIsOutsideTeamScope();

  const sentinelTeam = invitationSentinelTeam || userSentinelTeam;

  // The last-viewed team stays in context on the All Teams pages, so brand
  // them as Decisiv, same as for a user with no team.
  const showDecisivBrand = needsSentinelTeam || isOutsideTeamScope;

  const teamName =
    showDecisivBrand || !userSentinelTeam.hasSentinelTeam
      ? t`Sentinel Managed Care`
      : sentinelTeam?.name;
  const primaryText = variant === 'full' ? teamName : undefined;

  const applicationName = showDecisivBrand
    ? t`Decisiv`
    : sentinelTeam?.applicationName ?? '';
  const secondaryText = variant === 'full' ? applicationName : undefined;
  return (
    <KDSTopNav.BrandInfo
      logo={showDecisivBrand ? decisivLogo : sentinelTeam?.logo?.url}
      primaryText={primaryText}
      secondaryText={secondaryText}
    />
  );
}

BrandInfo.propTypes = {
  variant: PropTypes.oneOf(['full', 'compact']),
};

BrandInfo.defaultProps = {
  variant: 'full',
};

export default BrandInfo;
